export default function QuizBackButton({
  text,
  backgroundColor,
  textColor,
  onClick,
}) {
  return (
    <button
      onClick={onClick}
      onPointerDown={onClick}
      className="rounded-md h-14 px-10 py-3 font-semibold focus:outline-none transition hover:brightness-105"
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
      }}
    >
      {text}
    </button>
  );
}